import React from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

const UPDATED = "June 2026";

function Sec({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="font-heading font-bold text-lg text-foreground">{title}</h2>
      <div className="text-sm text-muted-foreground leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function TermsPage() {
  return (
    <div data-testid="terms-page" className="max-w-3xl mx-auto space-y-8">
      <div className="space-y-2">
        <div className="w-12 h-12 rounded-2xl bg-red-600/15 grid place-items-center">
          <FileText className="w-6 h-6 text-red-600" />
        </div>
        <h1 className="font-heading font-extrabold text-3xl">Terms of Service</h1>
        <p className="text-xs text-muted-foreground">Last updated: {UPDATED}</p>
      </div>

      <Sec title="1. Acceptance of terms">
        <p>By accessing or using Stewart Capital Investments ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.</p>
      </Sec>

      <Sec title="2. Not financial advice">
        <p>The Service provides market data, news, AI-generated commentary, and portfolio tracking tools for informational and educational purposes only. Nothing on the Service constitutes financial, investment, tax, or legal advice, or a recommendation to buy, sell, or hold any security. You are solely responsible for your investment decisions. Always consult a qualified professional before investing.</p>
      </Sec>

      <Sec title="3. Market data">
        <p>Quotes, charts, indexes, and related data are sourced from public providers (including Yahoo Finance) and may be delayed, inaccurate, or unavailable. Prices are near-real-time, not guaranteed exchange-grade streaming data. We are not liable for any losses arising from reliance on this data.</p>
      </Sec>

      <Sec title="4. AI-generated content">
        <p>AI features (cause analysis, ratings, and article drafts) are produced by third-party language models and may contain errors, omissions, or outdated information. AI output is not a professional recommendation and should be independently verified.</p>
      </Sec>

      <Sec title="5. Practice Trading">
        <p>The Practice Trading feature uses <span className="font-semibold text-foreground">virtual money only</span>. No real funds are used, held, or at risk, and no real securities are bought or sold. It is a simulation for learning purposes and results do not reflect actual trading outcomes.</p>
      </Sec>

      <Sec title="6. Accounts">
        <p>You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. You agree to provide accurate information and to use the Service in compliance with applicable laws.</p>
      </Sec>

      <Sec title="7. Acceptable use">
        <p>You agree not to misuse the Service, including attempting to disrupt it, access it through automated means beyond normal use, reverse-engineer it, or use it for unlawful purposes.</p>
      </Sec>

      <Sec title="8. Limitation of liability">
        <p>The Service is provided "as is" without warranties of any kind. To the maximum extent permitted by law, Stewart Capital Investments shall not be liable for any indirect, incidental, or consequential damages, or for any investment losses, arising from your use of the Service.</p>
      </Sec>

      <Sec title="9. Changes">
        <p>We may update these Terms from time to time. Continued use of the Service after changes take effect constitutes acceptance of the revised Terms.</p>
      </Sec>

      <Sec title="10. Contact">
        <p>Questions about these Terms? Contact us at <span className="text-foreground">legal@stewartcapfinance.com</span>.</p>
      </Sec>

      <div className="pt-4 border-t border-border text-sm">
        <Link to="/privacy" data-testid="terms-to-privacy" className="text-red-600 hover:underline">Read our Privacy Policy →</Link>
      </div>
    </div>
  );
}
